import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(3.000000, 0.000000)">
          <g transform="translate(0.000000, 3.000000)" stroke="currentColor" strokeWidth="1.5">
            <path
              d="M8,0 C8,0.55228475 7.79893091,1.83906319 9,1.83906319 C10.2010691,1.83906319 10,0.55228475 10,0"
              transform="translate(9.000000, 0.919532) scale(1, -1) translate(-9.000000, -0.919532) "
            />
            <path d="M7.84425868,1.83906319 L10.1557413,1.83906319 C13.3834363,1.83906319 16,4.45562693 16,7.68332188 L16,13.1550097 C16,13.3953218 16.0865391,13.6275974 16.2437793,13.8093263 L17,14.6833219 C17.2524602,14.9751006 17.2205863,15.4162935 16.9288076,15.6687537 C16.8018478,15.7786051 16.6395751,15.8390632 16.4716879,15.8390632 L1.52831214,15.8390632 C1.14247408,15.8390632 0.829690533,15.5262796 0.829690533,15.1404416 C0.829690533,14.9725544 0.890148613,14.8102817 1,14.6833219 L1.75622073,13.8093263 C1.91346091,13.6275974 2,13.3953218 2,13.1550097 L2,7.68332188 C2,4.45562693 4.61656374,1.83906319 7.84425868,1.83906319 Z" />
            <path d="M7,16.5890632 C7,17.6936327 7.8954305,18.5890632 9,18.5890632 C10.1045695,18.5890632 11,17.6936327 11,16.5890632" />
          </g>
          <circle id="Oval" fill="#1ea8a3" cx="17.5" cy="2.5" r="2.5" />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
